<template>
    <div class="wishInformation" v-if="activeWish">
        <h3>Wensinformatie</h3>
        <InfoGrid>
            <InfoHeader>Opmerking</InfoHeader>
            <span>{{ activeWish.description }}</span>
            <template v-if="activeWish.doesntWantToWorkBegin && activeWish.doesntWantToWorkEnd">
                <InfoHeader>Wil niet werken</InfoHeader>
                <span>Vanaf {{ returnTime(activeWish.doesntWantToWorkBegin) }} tot {{ returnTime(activeWish.doesntWantToWorkEnd) }}</span>
            </template>
            <template v-if="activeWish.wantsShiftId1 && shifts">
                <InfoHeader>Wil dienst</InfoHeader>
                <div>
                    <span
                        class="shiftLabel"
                        v-if="activeWish.wantsShiftId1"
                        v-text="shifts[activeWish.wantsShiftId1].template!.code"
                    />
                    <span v-if="activeWish.wantsShiftId2"> of </span>
                    <span
                        class="shiftLabel"
                        v-if="activeWish.wantsShiftId2"
                        v-text="shifts[activeWish.wantsShiftId2].template!.code"
                    />
                    <span v-if="activeWish.wantsShiftId3"> of </span>
                    <span
                        class="shiftLabel"
                        v-if="activeWish.wantsShiftId3"
                        v-text="shifts[activeWish.wantsShiftId3].template!.code"
                    />
                </div>
            </template>
        </InfoGrid>
    </div>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import Dates from '@cquential/date-utils';
    import {PersonalPlanningWish, Shift} from '@cquential/api';
    import InfoGrid from '@/components/Branding/InfoGrid.vue';
    import InfoHeader from '@/components/Branding/InfoHeader.vue';

    @Component({
        components: {
            InfoGrid,
            InfoHeader,
        },
    })
    export default class WishInformation extends Vue {
        @Prop() public activeWish?: PersonalPlanningWish;
        @Prop({type: Date, required: true}) public date!: Date;
        @Prop() public shifts?: Record<number, Shift>;

        public returnTime(value: Date): string {
            let addition: string = '';
            if (this.date && value > this.date) {
                addition = ' (+1)';
            }

            return Dates.Formatter.formatTime(value) + addition;
        }
    }
</script>

<style lang="scss" scoped>
    h3 {
        margin-top: 0;
    }

    .shiftLabel {
        font-weight: 700;
    }

    .wishInformation {
        margin: 1rem 0;
        padding: 1rem;
        border-radius: 0.25rem;
        background: var(--wish-information-background);
    }
</style>
